import styled from '@emotion/styled';

const LevelWrapper = styled('section')({
  marginLeft: -12,
  marginRight: -12,
  marginBottom: 50,
  display: 'flex',
});

export default LevelWrapper;
